module.exports = __webpack_public_path__ + "static/social-media-vp9-98e0af1a91815853ce7ab35b964b8df4.webm";